/* tslint:disable */

import React from "react"

const DropDownIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path 
          d="M7,10L12,15L17,10H7Z"
          fill="#000000"
        />
        </svg>
    </div>
  )
}

export default DropDownIcon
